module.exports = __webpack_public_path__ + "images/emoji/train2.2d8a024c5e1ba4a463fa.png";